export type CatalogDefaultSearch = {
  id: string;
  slug: string;
  name: string;
  description: string;
  forWhom: string;
  category: "valor" | "renda" | "recuperacao" | "risco";
  catalogPath: string;
  queryString: string;
};

export const CATALOG_DEFAULT_SEARCHES: CatalogDefaultSearch[] = [
  {
    id: "desagio-pvp-menor-1",
    slug: "desagio-pvp-menor-1",
    name: "FIIs com deságio (P/VP < 1)",
    description:
      "Fundos com preço abaixo do valor patrimonial por cota, filtrando apenas casos com DY não negativo.",
    forWhom:
      "Boa para quem busca entrada com desconto patrimonial e quer começar por casos de valuation mais conservador.",
    category: "valor",
    catalogPath: "/catalogo",
    queryString:
      "fundTypes=FII&currentPvpMax=1.00&dy12mMin=0.00&sort=dy12mPct:desc",
  },
  {
    id: "arroz-feijao-tijolo",
    slug: "arroz-feijao-tijolo",
    name: "Tijolo diversificado e líquido",
    description:
      "FIIs de tijolo com alta exposição imobiliária, mais de 1.000 cotistas e liquidez média diária de pelo menos R$ 100.",
    forWhom:
      "Boa para quem procura FIIs de tijolo mais diversificados e com melhor capacidade de entrada e saída.",
    category: "renda",
    catalogPath: "/catalogo",
    queryString:
      "fundTypes=FII&classificacao=tijolo&concentracaoTijoloMin=70.00&cotistasMin=1.001&liquidezDiaria30dMin=100&dy12mMin=0.00&sort=dy12mPct:desc",
  },
  {
    id: "fiis-recuperacao",
    slug: "fiis-recuperacao",
    name: "FIIs possivelmente em recuperação",
    description:
      "FIIs com distância relevante da máxima de 12m e sinal de melhora no resultado de caixa.",
    forWhom:
      "Boa para quem aceita mais volatilidade em busca de fundos que podem estar numa virada operacional.",
    category: "valor",
    catalogPath: "/catalogo",
    queryString:
      "fundTypes=FII&cotistasMin=5.000&distanceTo12mHighMin=20.00&cashTrendStatus=NEGATIVO_COM_MELHORA&dy12mMin=0.00&sort=dy12mPct:desc",
  },
  {
    id: "fiis-defensivos-renda",
    slug: "fiis-defensivos-renda",
    name: "FIIs defensivos de renda",
    description:
      "Vacância e inadimplência controladas, com base relevante de cotistas.",
    forWhom:
      "Boa para quem prioriza estabilidade de renda e quer reduzir riscos operacionais mais comuns.",
    category: "renda",
    catalogPath: "/catalogo",
    queryString:
      "fundTypes=FII&vacanciaMax=10.00&inadimplenciaMax=1.00&cotistasMin=15.000&dy12mMin=0.00&sort=dy12mPct:desc",
  },
  {
    id: "fiis-liquidos-posicao",
    slug: "fiis-liquidos-posicao",
    name: "FIIs líquidos para posição",
    description:
      "FIIs com liquidez diária mais alta para montagem de posição com menor fricção.",
    forWhom:
      "Boa para quem quer negociar com mais agilidade e menor risco de ficar preso em ativos pouco líquidos.",
    category: "renda",
    catalogPath: "/catalogo",
    queryString:
      "fundTypes=FII&liquidezDiaria30dMin=1.000.000&cotistasMin=20.000&dy12mMin=0.00&sort=dy12mPct:desc",
  },
  {
    id: "fiis-base-10",
    slug: "fiis-base-10",
    name: "FIIs base 10",
    description:
      "FIIs com cota em faixa mais acessível (de R$ 10 até R$ 99,99), pensando em aportes mensais menores.",
    forWhom:
      "Boa para quem está começando com pouco capital e quer montar posição aos poucos sem abrir mão dos dividendos.",
    category: "renda",
    catalogPath: "/catalogo",
    queryString:
      "fundTypes=FII&currentPriceMin=10.00&currentPriceMax=99.99&dy12mMin=0.00&sort=dy12mPct:desc",
  },
  {
    id: "fiis-valor-base-solida",
    slug: "fiis-valor-base-solida",
    name: "FIIs de valor com base sólida",
    description:
      "FII com P/VP descontado, base de cotistas ampla e caixa em melhora.",
    forWhom:
      "Boa para quem busca combinação de preço atrativo com sinais de maior robustez de base e caixa.",
    category: "valor",
    catalogPath: "/catalogo",
    queryString:
      "fundTypes=FII&currentPvpMax=0.95&cotistasMin=15.000&cashTrendStatus=POSITIVO&dy12mMin=0.00&sort=dy12mPct:desc",
  },
  {
    id: "fiis-tijolo-diversificados",
    slug: "fiis-tijolo-diversificados",
    name: "FIIs de tijolo diversificados",
    description:
      "FIIs de tijolo com vacância controlada, boa liquidez e menor risco operacional de ocupação.",
    forWhom:
      "Boa para quem quer exposição a imóveis com foco em diversificação e disciplina de risco operacional.",
    category: "renda",
    catalogPath: "/catalogo",
    queryString:
      "fundTypes=FII&classificacao=tijolo&concentracaoTijoloMin=70.00&vacanciaMax=12.00&liquidezDiaria30dMin=300.000&dy12mMin=0.00&sort=dy12mPct:desc",
  },
  {
    id: "fiis-papel-risco-controlado",
    slug: "fiis-papel-risco-controlado",
    name: "FIIs de papel com risco controlado",
    description:
      "Fundos de papel com inadimplência mais baixa, base mínima de cotistas e caixa em situação positiva.",
    forWhom:
      "Boa para quem quer renda de papel com foco maior em disciplina de crédito e estabilidade.",
    category: "risco",
    catalogPath: "/catalogo",
    queryString:
      "fundTypes=FII&classificacao=papel&inadimplenciaMax=2.00&cotistasMin=5.000&cashTrendStatus=POSITIVO&dy12mMin=0.00&sort=dy12mPct:desc",
  },
  {
    id: "fiis-baixa-alavancagem",
    slug: "fiis-baixa-alavancagem",
    name: "FIIs com menor alavancagem",
    description:
      "FIIs com índice de alavancagem mais baixo e base relevante de investidores.",
    forWhom:
      "Boa para quem quer reduzir exposição a dívida e priorizar balanços mais conservadores.",
    category: "risco",
    catalogPath: "/catalogo",
    queryString:
      "fundTypes=FII&leverageIndexScoreMax=35.00&cotistasMin=5.000&dy12mMin=0.00&sort=dy12mPct:desc",
  },
  {
    id: "fiis-baixa-sensibilidade-selic",
    slug: "fiis-baixa-sensibilidade-selic",
    name: "FIIs menos sensíveis à Selic",
    description:
      "Fundos com menor sensibilidade estimada à Selic, buscando menor oscilação em cenários de juros.",
    forWhom:
      "Boa para quem quer reduzir dependência do ciclo de juros na seleção de ativos.",
    category: "risco",
    catalogPath: "/catalogo",
    queryString:
      "fundTypes=FII&selicSensitivityScoreMax=35.00&cotistasMin=5.000&dy12mMin=0.00&sort=dy12mPct:desc",
  },
  {
    id: "fiis-alta-sensibilidade-selic",
    slug: "fiis-alta-sensibilidade-selic",
    name: "FIIs mais sensíveis à Selic",
    description:
      "Fundos com maior sensibilidade estimada ao ciclo de juros, com base mínima de cotistas.",
    forWhom:
      "Boa para quem quer montar posição mais tática para cenários de alta ou queda da Selic.",
    category: "risco",
    catalogPath: "/catalogo",
    queryString:
      "fundTypes=FII&selicSensitivityScoreMin=65.00&cotistasMin=5.000&dy12mMin=0.00&sort=dy12mPct:desc",
  },
  {
    id: "fiis-descontados-liquidos",
    slug: "fiis-descontados-liquidos",
    name: "FIIs descontados e líquidos",
    description:
      "Combina desconto patrimonial com liquidez diária e base mínima de cotistas.",
    forWhom:
      "Boa para quem quer equilíbrio entre preço atrativo e capacidade prática de montar/desmontar posição.",
    category: "valor",
    catalogPath: "/catalogo",
    queryString:
      "fundTypes=FII&currentPvpMax=0.95&liquidezDiaria30dMin=500.000&cotistasMin=5.000&dy12mMin=0.00&sort=dy12mPct:desc",
  },
];
